export const resetPassword = {
    title: 'Reset Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm new password',
    resetSuccess: 'You have successfully reset your password',
    buttonSave: 'Save',
};
